// Mock data for Sadie's Mission Dog Boarding

export const services = [
  {
    id: 1,
    title: "Dog Boarding",
    description: "Safe, comfortable overnight care for your furry friend in our spacious facility",
    icon: "home",
    features: ["24/7 Supervision", "Individual Kennels", "Outdoor Play Areas", "Comfortable Bedding"]
  },
  {
    id: 2,
    title: "Day Boarding",
    description: "Full-day care and socialization while you're at work or away for the day",
    icon: "sun",
    features: ["Group Play Sessions", "Individual Attention", "Meal Service", "Activity Updates"]
  },
  {
    id: 3,
    title: "Private Custom Boarding",
    description: "Personalized one-on-one care tailored to your dog's unique needs",
    icon: "heart",
    features: ["Dedicated Caregiver", "Custom Schedule", "Special Dietary Needs", "Medical Care Available"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Eric",
    location: "BC, Canada",
    rating: 5,
    text: "Starting back in 2019, Jen started walking my dog Envy a few times a week while I worked long 12+ hour days. What began as walks quickly turned into boarding when I travelled — and eventually long-term boarding for up to four months at a time when I was away for work.\n\nJen was never phased by Envy's breed, an XL American Bully, as she showed a calm confidence, understanding, and genuine love from day one. Even with two small kids at the time, her whole family welcomed Envy like she was their own, including her own two dogs.\n\nEnvy wasn't just boarded — she was part of their family.",
    date: "2025-02-19"
  }
];

export const pricingPlaceholder = [
  {
    service: "Dog Boarding",
    price: "Contact for pricing",
    unit: "per night"
  },
  {
    service: "Day Boarding",
    price: "Contact for pricing",
    unit: "per day"
  },
  {
    service: "Private Custom Boarding",
    price: "Contact for pricing",
    unit: "custom rate"
  }
];

export const detailedPricing = {
  dogBoarding: {
    title: "Dog Boarding",
    options: [
      {
        name: "1 Dog",
        price: "$60",
        unit: "per 24 hours",
        description: "Comfortable shared cabin with supervised group play"
      },
      {
        name: "2 Dogs*",
        price: "$102",
        unit: "per 24 hours",
        savings: "15% savings per dog",
        description: "Dogs from same household share a large cabin together"
      }
    ],
    note: "*Dogs must be from the same household and will be in a large shared cabin together.",
    extendedStayDiscount: "Stay 8+ nights and receive a 10% discount on your full stay (applied to regular and tailored care 1 and 2 dog bookings).",
    cancellationPolicy: {
      regular: "Regular Season Bookings: We require a minimum 3 day notice from the date of your check-in in order to receive a full refund.",
      peak: {
        fullRefund: "Peak Season Bookings: We require a minimum 5 day notice from the date of your check-in in order to receive a full refund (spring, summer and winter breaks).",
        partialRefund: "We require a minimum of 3 day notice from the date of your check-in to receive a 50% refund."
      }
    }
  },
  tailoredCare: {
    title: "Tailored Care**",
    options: [
      {
        name: "1 Dog",
        price: "$80",
        unit: "per 24 hours",
        description: "Private play and walks, 1:1 attention"
      },
      {
        name: "2 Dogs*",
        price: "$136",
        unit: "per 24 hours",
        description: "Dogs from same household with private care"
      }
    ],
    note: "**Tailored care is for those dogs who prefer humans over their furry friends and require private play and walks separate from the other dog guests. This can also include a stay for dogs who need a calm space and 1:1 24hr medical care (recovering from a surgery)."
  },
  dayBoarding: {
    title: "Day Boarding",
    options: [
      {
        name: "1 Dog",
        price: "$40",
        unit: "max. 12 hours",
        description: "Full-day care without overnight stay"
      },
      {
        name: "2 Dogs*",
        price: "$64",
        unit: "max. 12 hours",
        savings: "20% savings",
        description: "Dogs from same household"
      }
    ],
    note: "*To receive 20% discount for 2 dogs per day, dogs must be from the same household.",
    bulkDiscount: "Pre-pay for 10+ day boarding passes and receive 15% off the total.",
    cancellationPolicy: "Cancellation Policy: A minimum of 24 hours notice is required to receive a full refund and for a no-show or cancellation under 24 hours, a credit will be applied to your account for future use."
  }
};

export const additionalServices = [
  "Spa Baths",
  "Medication Administration - $5 / day",
  "Special Dietary Accommodations (included)",
  "Pick-up & Drop-off Service - Contact to Discuss Options and Pricing",
  "Exploration on Property (included) - Play in the fully fenced back yard filled with logs, creeks and endless adventures"
];

export const dogBoardingAddOns = [
  {
    name: "20 min Private Walk",
    price: "$15",
    description: "One-on-one walk with your dog"
  },
  {
    name: "45 min Private Walk/Small Hike",
    price: "$30",
    description: "Extended walk or small hiking adventure"
  },
  {
    name: "15 min Private Ball/Stick Throw in Pond",
    price: "$20",
    description: "Fun water play session"
  },
  {
    name: "20 min 1:1 Agility Session",
    price: "$20",
    description: "Private agility training and play"
  },
  {
    name: "Bath During Stay",
    price: "$25",
    description: "Basic bath and dry"
  },
  {
    name: "Full Spa Bath (Evening Before Checkout)",
    price: "$40",
    description: "Includes full bath, blow dry and brush/de-shedding"
  },
  {
    name: "Fully Private Cabin",
    price: "$15 added",
    unit: "per 24 hours",
    description: "Your dog stays in their own private cabin"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_dog-boarding-site/artifacts/37k4ehrn_IMG_3683.jpeg",
    alt: "Happy dogs at Sadie's Mission"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_dog-boarding-site/artifacts/3ekazraz_IMG_4952.jpeg",
    alt: "Dogs enjoying their stay"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/jq6fnfjj_IMG_3658.jpeg",
    alt: "Dogs enjoying their stay"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/a953i02r_IMG_3654.jpeg",
    alt: "Dogs playing together"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/xwl3vu8c_780C1C58-A885-4F57-A541-CA176C639690.png",
    alt: "Sadie - Our namesake dog"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/zs5ipe7d_FB9091F9-7128-4D07-8452-D33769EA1383.jpeg",
    alt: "Future site of Sadie's Mission"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/z9lmnbd1_IMG_4740.jpeg",
    alt: "Beautiful pond on the property"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/sm2jhd9w_IMG_4755.jpeg",
    alt: "Site preparation in progress"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/inki77jl_IMG_4996.jpeg",
    alt: "Play area preparation"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/be3lc6zw_IMG_4864.jpeg",
    alt: "Facility construction progress"
  }
];

// Mock booking data structure
export const mockBookings = [];

// Mock dog profiles
export const mockDogProfiles = [];

// Daily Photo Updates - Mock data for dogs currently boarding
export const dailyPhotoUpdates = [
  {
    id: 1,
    dogName: "Max",
    breed: "Golden Retriever",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fwmlo944_IMG_3683.jpeg",
    caption: "Max enjoying his morning play session in the outdoor area!",
    date: "2026-01-11",
    time: "10:30 AM",
    activity: "Playtime"
  },
  {
    id: 2,
    dogName: "Bella",
    breed: "Labrador",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fmkttcif_IMG_3739.jpeg",
    caption: "Bella made a new friend today! They're inseparable.",
    date: "2026-01-11",
    time: "2:15 PM",
    activity: "Socializing"
  },
  {
    id: 3,
    dogName: "Charlie",
    breed: "Beagle",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/jq6fnfjj_IMG_3658.jpeg",
    caption: "Charlie taking a well-deserved nap after an active morning!",
    date: "2026-01-11",
    time: "3:45 PM",
    activity: "Rest Time"
  },
  {
    id: 4,
    dogName: "Luna",
    breed: "Husky",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/a953i02r_IMG_3654.jpeg",
    caption: "Luna loves her afternoon snack time!",
    date: "2026-01-11",
    time: "4:00 PM",
    activity: "Meal Time"
  },
  {
    id: 5,
    dogName: "Max",
    breed: "Golden Retriever",
    photoUrl: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/xwl3vu8c_780C1C58-A885-4F57-A541-CA176C639690.png",
    caption: "Max showing off his fetch skills! Such a good boy.",
    date: "2026-01-10",
    time: "11:00 AM",
    activity: "Playtime"
  },
  {
    id: 6,
    dogName: "Bella",
    breed: "Labrador",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fwmlo944_IMG_3683.jpeg",
    caption: "Bella enjoying the sunshine in our outdoor play area.",
    date: "2026-01-10",
    time: "1:30 PM",
    activity: "Outdoor Time"
  },
  {
    id: 7,
    dogName: "Rocky",
    breed: "German Shepherd",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fmkttcif_IMG_3739.jpeg",
    caption: "Rocky being a gentle giant with the smaller dogs today!",
    date: "2026-01-10",
    time: "3:00 PM",
    activity: "Socializing"
  },
  {
    id: 8,
    dogName: "Daisy",
    breed: "Corgi",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fwmlo944_IMG_3683.jpeg",
    caption: "Daisy's adorable smile makes everyone's day brighter!",
    date: "2026-01-10",
    time: "5:00 PM",
    activity: "Playtime"
  },
  {
    id: 9,
    dogName: "Cooper",
    breed: "Australian Shepherd",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/fmkttcif_IMG_3739.jpeg",
    caption: "Cooper showing his herding instincts during group play!",
    date: "2026-01-09",
    time: "10:00 AM",
    activity: "Group Play"
  },
  {
    id: 10,
    dogName: "Luna",
    breed: "Husky",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/jq6fnfjj_IMG_3658.jpeg",
    caption: "Luna cooling off with some water play!",
    date: "2026-01-09",
    time: "2:30 PM",
    activity: "Water Play"
  },
  {
    id: 11,
    dogName: "Buddy",
    breed: "Poodle",
    photoUrl: "https://customer-assets.emergentagent.com/job_faaab592-df79-4f4e-b5de-406d1ad1eea0/artifacts/a953i02r_IMG_3654.jpeg",
    caption: "Buddy looking handsome after his grooming session!",
    date: "2026-01-09",
    time: "4:15 PM",
    activity: "Grooming"
  },
  {
    id: 12,
    dogName: "Sadie",
    breed: "Mixed Breed",
    photoUrl: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/xwl3vu8c_780C1C58-A885-4F57-A541-CA176C639690.png",
    caption: "Our namesake Sadie supervising all the fun activities!",
    date: "2026-01-09",
    time: "5:30 PM",
    activity: "Supervision"
  }
];

// Get unique dog names for filter
export const getUniqueDogNames = () => {
  return [...new Set(dailyPhotoUpdates.map(update => update.dogName))];
};

// Get unique dates for filter
export const getUniqueDates = () => {
  return [...new Set(dailyPhotoUpdates.map(update => update.date))].sort().reverse();
};

// Get unique activities for filter
export const getUniqueActivities = () => {
  return [...new Set(dailyPhotoUpdates.map(update => update.activity))];
};

// Staff Members
export const staffMembers = [
  {
    id: 1,
    name: "Jen Decker",
    role: "Owner/Operator",
    photoUrl: "https://customer-assets.emergentagent.com/job_88aa9ec7-4e33-45f5-9f03-fcaf81350df6/artifacts/8j0nyvlr_IMG_5761.jpeg",
    bio: `Jen Decker, founder of Sadie's Mission Dog Boarding, was born and raised in Port Moody, where she met her husband in middle school and later built their family in the Tri-Cities. Their home was always filled with rescue dogs — from local BC shelters to rescues from Taiwan, Blaine, and California. Through these experiences, Jen developed a deep love and understanding for pitbull-type breeds and the many misunderstood dogs who simply need someone to see their heart.

For nearly 20 years, Jen worked as an Office Manager at a large engineering firm. While she built a successful career in the corporate world, her true passion was always with animals. She eventually made the decision to trade in boardrooms for backyards — choosing a more intentional, laidback lifestyle doing what she loves most: caring for dogs.

Her vision became even more meaningful after her youngest son was diagnosed with autism and ADHD. Watching the powerful bond between him and their dogs reinforced her belief that animals bring comfort, confidence, and calm in a way nothing else can.

That calling led Jen and her family to Mission, where Jen created Sadie's Mission Dog Boarding — a safe, loving home away from home. She specializes in providing personalized, 1:1 care, especially for dogs who may feel overwhelmed in traditional boarding environments or who prefer human companionship over large groups.

At Sadie's Mission, every dog is treated like family — with love, structure, exploration, and joy.

Because here, it's more than boarding.
It's belonging.`,
    certifications: [],
    specialty: "Personalized 1:1 Care"
  },
  {
    id: 2,
    name: "The OG…Ms. Envy Ray",
    role: "Chief Inspiration Officer",
    photoUrl: "https://customer-assets.emergentagent.com/job_dog-boarding-site/artifacts/h3xzfeso_IMG_5747.jpeg",
    photoUrl2: "https://customer-assets.emergentagent.com/job_dog-boarding-site/artifacts/i196kdek_IMG_8995.jpeg",
    bio: `Please meet the OG, the Grand Dame, the Big Baby…Ms. Envy Ray.

In late 2019, our lives changed the moment a beautiful American XL Bully named Envy moved in next door. Without hesitation — and without even being invited — Jen ran across the street to meet her. It was love at first sight.

Envy had the most incredible, one-of-a-kind presence. She was happy, energetic, and full of life… yet just as content curled up on the couch for snuggles. The true definition of a "house hippo."

Jen's husband jokingly warned her not to get too attached. Of course, she did anyway. What started as a simple act of kindness — walking Envy while her dad, Eric, worked long 12+ hour shifts — quickly became something much more. Their bond deepened. Walks turned into sleepovers. Sleepovers turned into short-term boarding. Eventually, Envy became family.

Through Envy, we discovered something powerful: when dogs are loved like your own, everything changes. The trust Eric placed in us, and the connection we built with Envy, confirmed what Jen had always felt in her heart — this was her calling.

Our mission was born from that bond.

We created a dog boarding experience where dogs aren't just clients — they're family. A place where they are known, loved, snuggled, exercised, and cared for as individuals. A home away from home.

Envy showed us what was possible.
And we've been building that dream ever since. 🐾`,
    dadQuote: `I met Jen, and her family, in 2019 when we became neighbours, and she started walking my dog Envy a few times a week while I worked long 12+ hour days around the Lower Mainland. What began as walks quickly turned into boarding when I travelled — and eventually long-term boarding for up to four months at a time when I was away for work.

Envy is an American XL Bully — a strong, often misunderstood breed — but Jen was never phased. She showed calm confidence, understanding, and genuine love from day one. Even with two small kids at the time, her whole family welcomed Envy like she was their own, including her own two dogs.

Envy wasn't just boarded — she was part of their family.

Jen has a natural connection with dogs, especially bigger, stronger breeds. Watching how Envy thrived in her care gave me complete peace of mind and showed me that Jen truly has a gift.

I'll always be grateful for the love she gave Envy.

— Eric Ray`,
    certifications: [],
    specialty: "Being the Best Girl"
  }
];

// Helper function to simulate API delay
export const simulateApiDelay = (ms = 500) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// Mock booking submission
export const submitBooking = async (bookingData) => {
  await simulateApiDelay();
  const newBooking = {
    id: mockBookings.length + 1,
    ...bookingData,
    createdAt: new Date().toISOString(),
    status: "pending"
  };
  mockBookings.push(newBooking);
  return newBooking;
};

// Mock dog profile submission
export const submitDogProfile = async (dogData) => {
  await simulateApiDelay();
  const newProfile = {
    id: mockDogProfiles.length + 1,
    ...dogData,
    createdAt: new Date().toISOString()
  };
  mockDogProfiles.push(newProfile);
  return newProfile;
};
